/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-10.
 * Form configuration for despachos
 */
import {
    AUTOCOMPLETE,
    DATE,
    SELECT,
    TEXT,
    FILE,
    REMOTE_AUTOCOMPLETE
} from '../components/data-containers/formBuilder/types';
import { CUSTOMS_CLEARENCE_TYPES, VIA, COLORS } from '../data/selects';

export const getConfig = (actions, params = {}, formState = {}) => {
    /*if(params.statuses[0] != undefined || params.statuses[0] != null || params.statuses.length>1){
      for(var i=0; i <params.statuses.length; i++){
        ArrayTo.push({
          id: params.statuses[i].statusName,
          name: params.statuses[i].statusName
        })
      }
    }*/

    const status = {
        items: [
            { id: 'EN PROCESO', name: 'EN PROCESO' },
            { id: 'PRE ALERTADO', name: 'PRE ALERTADO' }
        ],
        displayProp: (item) => item.name
    };

    const selectedCustomsHouse = params.customsHousesList.items.find(ch => ch.uuid === formState.customsHouse);
    const requireRequestingNumber = selectedCustomsHouse && selectedCustomsHouse.ownOffice;
    const requestingNumberBasicRule = { key: 'validationMask', errorText: 'Por favor debe ser tipo XXXX-YYYYYYY' };
    const requestingNumberRules = requireRequestingNumber ?
        [requestingNumberBasicRule, { key: 'required', errorText: 'Campo Requerido' }] : [requestingNumberBasicRule];

    return {
        fields: [
            {
                fType: REMOTE_AUTOCOMPLETE,
                key: 'customer',
                tooltip: 'Agregar Nuevo Cliente',
                label: 'Cliente',
                dataSourceConfig: { text: 'name', value: 'id' },
                entity: 'customers',
                serviceName: 'customers',
                url: '/customers/search/findTop10ByNameIgnoreCaseContaining',
                projectionName: 'forListing',
                onAdd: actions.onAddClient
            },
            {
                fType: REMOTE_AUTOCOMPLETE,
                key: 'supplier',
                tooltip: 'Proveedor',
                label: 'Proveedor',
                dataSourceConfig: { text: 'name', value: 'id' },
                entity: 'suppliers',
                serviceName: 'suppliers',
                url: '/suppliers/search/findTop10ByNameIgnoreCaseContaining',
                projectionName: 'forListing',
                onAdd: actions.onAddSupplier
            },
            {
                fType: SELECT,
                key: 'type',
                floatingLabelText: 'Tipo',
                floatingLabelFixed: true,
                data: CUSTOMS_CLEARENCE_TYPES
            },
            {
                fType: DATE,
                key: 'arrivalTimestamp',
                floatingLabelFixed: true,
                textFieldStyle: { width: '100%' },
                hintText: 'Seleccionar',
                floatingLabelText: 'Fecha de Arribo / Salida'
            },
            {
                fType: DATE,
                key: 'requestingPaymentTimestamp',
                floatingLabelFixed: true,
                textFieldStyle: { width: '100%' },
                hintText: 'Seleccionar',
                floatingLabelText: 'Fecha Pago Pedimento'
            },
            {
                fType: TEXT,
                key: 'originDestination',
                floatingLabelFixed: true,
                floatingLabelText: 'Origen',
                hintText: 'China',
                fullWidth: true,
            },
            {
                fType: AUTOCOMPLETE,
                key: 'customsHouse',
                tooltip: 'Agregar Nueva Aduana',
                label: 'Aduana',
                dropdownCustomId: 'uuid',
                data: params.customsHousesList
            },
            {
                fType: TEXT,
                key: 'requestingNumber',
                floatingLabelFixed: true,
                floatingLabelText: 'Número de Pedimento',
                hintText: 'XXXX-YYYYYYY',
                fullWidth: true,
            },
            {
                fType: TEXT,
                key: 'comertialInvoiceNumber',
                floatingLabelFixed: true,
                floatingLabelText: 'No. Factura Comercial',
                hintText: '0000000000',
                fullWidth: true,
            },
            {
                fType: TEXT,
                key: 'shippingCompany',
                floatingLabelFixed: true,
                floatingLabelText: 'Arelolinea/Naviera/Carrier',
                hintText: 'Arelolinea/Naviera/Carrier',
                fullWidth: true,
            },
            {
                fType: TEXT,
                key: 'mawbMbl',
                floatingLabelFixed: true,
                floatingLabelText: 'MAWB/MBL',
                hintText: '0000',
                fullWidth: true,
            },
            {
                fType: TEXT,
                key: 'hawbHbl',
                floatingLabelFixed: true,
                floatingLabelText: 'HAWB/HBL',
                hintText: '0000',
                fullWidth: true,
            },
            {
                fType: SELECT,
                key: 'via',
                floatingLabelText: 'Vía',
                floatingLabelFixed: true,
                data: VIA
            },
            {
                fType: TEXT,
                key: 'packages',
                floatingLabelFixed: true,
                floatingLabelText: 'Bultos',
                hintText: '0x0 bultos',
                fullWidth: true,
            },
            {
                fType: TEXT,
                key: 'weight',
                floatingLabelFixed: true,
                floatingLabelText: 'Peso (Kg)',
                hintText: '00',
                fullWidth: true,
            },
            {
                fType: TEXT,
                key: 'customsValue',
                floatingLabelFixed: true,
                floatingLabelText: 'Valor Aduanal ($)',
                hintText: '00',
                fullWidth: true,
            },
            {
                fType: TEXT,
                key: 'merchandiseDescription',
                //containerStyle: { width: '100%' },
                floatingLabelFixed: true,
                floatingLabelText: 'Descripción de la mercancia',
                hintText: 'Añade aquí la descripción',
                fullWidth: true,
                multiLine: true,
                rows: 1,
                rowsMax: 5,
            },
            {
                fType: TEXT,
                key: 'comments',
                //containerStyle: { width: '100%' },
                floatingLabelFixed: true,
                floatingLabelText: 'Comentarios',
                hintText: 'Añade aquí tus comentarios',
                fullWidth: true,
                multiLine: true,
                rows: 1,
                rowsMax: 5,
            },
            {
                fType: SELECT,
                key: 'status',
                floatingLabelText: 'Selecciona un estado',
                floatingLabelFixed: true,
                data: status
            }
        ],
        rules: {
            customer: [{ key: 'required', errorText: 'Por favor, seleccione el cliente' }],
            supplier: [{ key: 'required', errorText: 'Por favor, seleccione al proveedor' }],
            arrivalTimestamp: [{ key: 'required', errorText: 'Por favor, seleccione la fecha de arribo' }],
            requestingNumber: requestingNumberRules,
            type: [{ key: 'required', errorText: 'Campo requerido' }],
            originDestination: [{ key: 'required', errorText: 'Campo requerido' }],
            customsHouse: [{ key: 'required', errorText: 'Campo requerido' }],
            shippingCompany: [{ key: 'required', errorText: 'Campo requerido' }],
            via: [{ key: 'required', errorText: 'Campo requerido' }],
            packages: [
                { key: 'required', errorText: 'Campo requerido' },
                { key: 'packagesRules', errorText: 'Indique el numero seguido de Concepto' }
            ],
            weight: [
                { key: 'required', errorText: 'Campo requerido' },
                { key: 'numberWithDecimals', errorText: 'Numero invalido' }
            ],
            status: [{ key: 'required', errorText: 'Campo requerido' }],
            customsValue: [{ key: 'onlyMonetaryValues', errorText: 'Por favor, ingrese valores monetarios' }]
        }
    };


};



// WEBPACK FOOTER //
// ./forms/despacho.js